import { Container } from '@mui/material';
import NotificationList from '../components/NotificationList';

const NotificationsPage = () => {
  return (
    <Container maxWidth="lg">
      <NotificationList />
    </Container>
  );
};

export default NotificationsPage;
